// SPDX-License-Identifier: AGPL-3.0-or-later

import {z} from 'zod';

// Micup: who a country setting reaches. Country codes, plus WORLDWIDE: every country no other rule names, an unknown
// country included.
export const REGION_WORLDWIDE = 'WORLDWIDE';
export const REGION_COUNTRY_MAX = 250;

function isUnique(values: ReadonlyArray<string>): boolean {
	return new Set(values).size === values.length;
}

export const RegionCountryCode = z
	.string()
	.trim()
	.toUpperCase()
	.regex(/^[A-Z]{2}$/)
	.describe('ISO 3166-1 alpha-2 country code; stored in upper case');

export const RegionCountryList = z
	.array(RegionCountryCode)
	.max(REGION_COUNTRY_MAX)
	.refine(isUnique, 'Countries must be unique')
	.describe('ISO 3166-1 alpha-2 country codes');

const RegionTargetCode = z
	.string()
	.trim()
	.toUpperCase()
	.refine((code) => code === REGION_WORLDWIDE || /^[A-Z]{2}$/.test(code), 'A country code or WORLDWIDE')
	.describe(`ISO 3166-1 alpha-2 country code, or ${REGION_WORLDWIDE} for every country no other rule names`);

export const RegionTarget = z
	.array(RegionTargetCode)
	.max(REGION_COUNTRY_MAX + 1)
	.refine(isUnique, 'Countries must be unique')
	.describe(`Country codes, and ${REGION_WORLDWIDE} for every other country (an unknown one included)`);

export type RegionTarget = z.infer<typeof RegionTarget>;
